import { MeasurementDimension } from '../query.types';

export const awsDimensions: Record<string, MeasurementDimension> = {
  kt_aws_src_acc_id: { Label: 'Account', Direction: 'src', Category: 'Amazon Web Services' },
  kt_aws_dst_acc_id: { Label: 'Account', Direction: 'dst', Category: 'Amazon Web Services' },
  kt_aws_src_acc_alias: { Label: 'Account Alias', Direction: 'src', Category: 'Amazon Web Services' },
  kt_aws_dst_acc_alias: { Label: 'Account Alias', Direction: 'dst', Category: 'Amazon Web Services' },
  kt_aws_src_acc_name: { Label: 'Account Name', Direction: 'src', Category: 'Amazon Web Services' },
  kt_aws_dst_acc_name: { Label: 'Account Name', Direction: 'dst', Category: 'Amazon Web Services' },
  kt_aws_src_vm_name: { Label: 'Instance Name', Direction: 'src', Category: 'Amazon Web Services' },
  kt_aws_dst_vm_name: { Label: 'Instance Name', Direction: 'dst', Category: 'Amazon Web Services' },
  kt_aws_src_vm_id: { Label: 'Instance', Direction: 'src', Category: 'Amazon Web Services' },
  kt_aws_dst_vm_id: { Label: 'Instance', Direction: 'dst', Category: 'Amazon Web Services' },
  kt_aws_src_region: { Label: 'Region', Direction: 'src', Category: 'Amazon Web Services' },
  kt_aws_dst_region: { Label: 'Region', Direction: 'dst', Category: 'Amazon Web Services' },
  kt_aws_src_zone: { Label: 'Zone Name', Direction: 'src', Category: 'Amazon Web Services' },
  kt_aws_dst_zone: { Label: 'Zone Name', Direction: 'dst', Category: 'Amazon Web Services' },
  kt_aws_src_zone_id: { Label: 'Zone ID', Direction: 'src', Category: 'Amazon Web Services' },
  kt_aws_dst_zone_id: { Label: 'Zone ID', Direction: 'dst', Category: 'Amazon Web Services' },
  kt_aws_src_vm_type: { Label: 'Instance Type', Direction: 'src', Category: 'Amazon Web Services' },
  kt_aws_dst_vm_type: { Label: 'Instance Type', Direction: 'dst', Category: 'Amazon Web Services' },
  kt_aws_src_image_id: { Label: 'Image ID', Direction: 'src', Category: 'Amazon Web Services' },
  kt_aws_dst_image_id: { Label: 'Image ID', Direction: 'dst', Category: 'Amazon Web Services' },
  kt_aws_src_sg: { Label: 'Security Group', Direction: 'src', Category: 'Amazon Web Services' },
  kt_aws_dst_sg: { Label: 'Security Group', Direction: 'dst', Category: 'Amazon Web Services' },
  kt_aws_src_asg: { Label: 'Auto Scaling Group', Direction: 'src', Category: 'Amazon Web Services' },
  kt_aws_dst_asg: { Label: 'Auto Scaling Group', Direction: 'dst', Category: 'Amazon Web Services' },
  kt_aws_src_pub_dns: { Label: 'Public DNS Name', Direction: 'src', Category: 'Amazon Web Services' },
  kt_aws_dst_pub_dns: { Label: 'Public DNS Name', Direction: 'dst', Category: 'Amazon Web Services' },
  kt_aws_src_priv_dns: { Label: 'Private DNS Name', Direction: 'src', Category: 'Amazon Web Services' },
  kt_aws_dst_priv_dns: { Label: 'Private DNS Name', Direction: 'dst', Category: 'Amazon Web Services' },
  kt_aws_src_vpc_id: { Label: 'VPC ID', Direction: 'src', Category: 'Amazon Web Services' },
  kt_aws_dst_vpc_id: { Label: 'VPC ID', Direction: 'dst', Category: 'Amazon Web Services' },
  kt_aws_src_vpc_name: {
    Label: 'VPC Name',
    Column: 'kt_aws_src_vpc_id',
    Direction: 'src',
    Category: 'Amazon Web Services'
  },
  kt_aws_dst_vpc_name: {
    Label: 'VPC Name',
    Column: 'kt_aws_dst_vpc_id',
    Direction: 'dst',
    Category: 'Amazon Web Services'
  },
  kt_aws_src_subnet_id: { Label: 'Subnet ID', Direction: 'src', Category: 'Amazon Web Services' },
  kt_aws_dst_subnet_id: { Label: 'Subnet ID', Direction: 'dst', Category: 'Amazon Web Services' },
  kt_aws_src_subnet_name: {
    Label: 'Subnet Name',
    Column: 'kt_aws_src_subnet_id',
    Direction: 'src',
    Category: 'Amazon Web Services'
  },
  kt_aws_dst_subnet_name: {
    Label: 'Subnet Name',
    Column: 'kt_aws_dst_subnet_id',
    Direction: 'dst',
    Category: 'Amazon Web Services'
  },
  kt_aws_src_vm_tags: { Label: 'Instance Tags', Direction: 'src', Category: 'Amazon Web Services' },
  kt_aws_dst_vm_tags: { Label: 'Instance Tags', Direction: 'dst', Category: 'Amazon Web Services' },
  kt_aws_action: { Label: 'Firewall Action', Category: 'Amazon Web Services' },
  kt_aws_status: { Label: 'Logging Status', Category: 'Amazon Web Services' }
};

export const azureDimensions: Record<string, MeasurementDimension> = {
  kt_az_src_inst_name: { Label: 'Instance Name', Direction: 'src', Category: 'Microsoft Azure' },
  kt_az_dst_inst_name: { Label: 'Instance Name', Direction: 'dst', Category: 'Microsoft Azure' },
  kt_az_src_inst_id: { Label: 'Instance', Direction: 'src', Category: 'Microsoft Azure' },
  kt_az_dst_inst_id: { Label: 'Instance', Direction: 'dst', Category: 'Microsoft Azure' },
  kt_az_src_region: { Label: 'Region', Direction: 'src', Category: 'Microsoft Azure' },
  kt_az_dst_region: { Label: 'Region', Direction: 'dst', Category: 'Microsoft Azure' },
  kt_az_src_zone: { Label: 'Zone', Direction: 'src', Category: 'Microsoft Azure' },
  kt_az_dst_zone: { Label: 'Zone', Direction: 'dst', Category: 'Microsoft Azure' },
  kt_az_src_inst_type: { Label: 'Instance Type', Direction: 'src', Category: 'Microsoft Azure' },
  kt_az_dst_inst_type: { Label: 'Instance Type', Direction: 'dst', Category: 'Microsoft Azure' },
  kt_az_src_fqdn: { Label: 'Public DNS Name', Direction: 'src', Category: 'Microsoft Azure' },
  kt_az_dst_fqdn: { Label: 'Public DNS Name', Direction: 'dst', Category: 'Microsoft Azure' },
  kt_az_src_vnet: { Label: 'VNet ID', Direction: 'src', Category: 'Microsoft Azure' },
  kt_az_dst_vnet: { Label: 'VNet ID', Direction: 'dst', Category: 'Microsoft Azure' },
  kt_az_src_subnet: { Label: 'Subnet Name', Direction: 'src', Category: 'Microsoft Azure' },
  kt_az_dst_subnet: { Label: 'Subnet Name', Direction: 'dst', Category: 'Microsoft Azure' },
  kt_az_src_rsrc_group: { Label: 'Resource Group', Direction: 'src', Category: 'Microsoft Azure' },
  kt_az_dst_rsrc_group: { Label: 'Resource Group', Direction: 'dst', Category: 'Microsoft Azure' },
  kt_az_src_public_ip: { Label: 'Public IP Address', Direction: 'src', Category: 'Microsoft Azure' },
  kt_az_dst_public_ip: { Label: 'Public IP Address', Direction: 'dst', Category: 'Microsoft Azure' },
  kt_az_src_sub_id: { Label: 'Subscription', Direction: 'src', Category: 'Microsoft Azure' },
  kt_az_dst_sub_id: { Label: 'Subscription', Direction: 'dst', Category: 'Microsoft Azure' },
  kt_az_src_sub_name: { Label: 'Subscription Name', Direction: 'src', Category: 'Microsoft Azure' },
  kt_az_dst_sub_name: { Label: 'Subscription Name', Direction: 'dst', Category: 'Microsoft Azure' }
};

export const cloudDimensionsBySubtype: Record<string, Record<string, MeasurementDimension>> = {
  aws: awsDimensions,
  azure: azureDimensions
};

export const cloudEnrichmentMap: Record<string, 'Vpcs' | 'Subnets'> = {
  kt_aws_src_vpc_name: 'Vpcs',
  kt_aws_dst_vpc_name: 'Vpcs',
  kt_aws_src_subnet_name: 'Subnets',
  kt_aws_dst_subnet_name: 'Subnets'
};
